<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">ダッシュボード</a>
            </li>
            <router-link tag="li" :to="{ name: 'group'}">
              <a>ゲートグループ一覧</a>
            </router-link>
            <li class="active">ゲートグループ編集</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>ゲートグループ編集</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
          <div class="alert alert-success" v-if="message_success">
            {{ message_success }}
          </div>
          <div class="alert alert-danger" v-if="message_error">
            {{ message_error }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="form-group">
                <div class="col-md-offset-2 col-md-10"></div>
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ゲートグループID</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control input-sm" disabled="" placeholder="ゲートグループId" v-model="groupInfor.groupId">
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-offset-2 col-md-10"><span id="name_error" class="error_m"></span></div>
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ゲートグループ名</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control input-sm" id="name" placeholder="ゲートグループ名" v-model="groupInfor.name">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ステータス</label>
                <div class="col-sm-1">
                  <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="groupInfor.isValid">
                  <span class="lbl"></span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1"></label>
                <div class="col-sm-10">
                  <router-link :to="{ name: 'group'}" class="btn cancel_bottom">
                    キャンセル
                  </router-link>
                  <button class="btn btn-info save_group_bottom" type="button" @click="validateBeforeSubmit">
                    保存
                  </button>
                </div>
              </div>
              <div id="accordion" class="accordion-style1 panel-group">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a class="accordion-toggle" data-toggle="collapse" href="#passage" aria-expanded="true" @click="getData">
                        <i class="ace-icon fa fa-angle-right bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                        &nbsp;ユーザー
                      </a>
                    </h4>
                  </div>
                  <div class="panel-collapse collapse" id="passage">
                    <div class="panel-body">
                      <table style="min-width:100%" class="table table-striped table-bordered table-hover dataTable">
                        <thead>
                          <tr>
                            <th class="center" v-if="listUserGroup != null" style="width:50px!important">
                              <label class="pos-rel">
                                <input type="checkbox" class="ace" v-model="selectAllUser">
                                <span class="lbl"></span>
                              </label>
                            </th>
                            <th>ユーザーID</th>
                            <th>ユーザー名/ふりがな</th>
                            <th>備考.1</th>
                            <th>備考.2</th>
                            <th class="center">ステータス</th>
                          </tr>
                        </thead>
                        <tbody v-if="listUserGroup != null">
                          <template v-for="(item, index) in listUserGroup">
                            <tr v-bind:class="{'selected': rowSelected(item.groupPassageId)}" :key="index">
                              <td class="center" style="width:50px">
                                <label class="pos-rel">
                                  <input type="checkbox" class="ace" :value="item.groupPassageId" v-model="selectedUserId">
                                  <span class="lbl"></span>
                                </label>
                              </td>
                              <td>{{item.userId.userId}}</td>
                              <td>{{item.userId.name}}/{{item.userId.furigana}}</td>
                              <td>{{item.userId.option1}}</td>
                              <td>{{item.userId.option2}}</td>
                              <td class="center">
                                <span v-if="item.userId.isValid">有効</span>
                                <span v-else >無効</span>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="5">{{ messageData }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="row pd-t-10">
                        <div class="col-xs-12">
                          <div class="dataTables_paginate paging_simple_numbers" v-if="pagesGroupUser>0 && listUserGroup!==null">
                            <paginate
                              :page-count="pagesGroupUser"
                              :page-range="3"
                              :margin-pages="2"
                              :click-handler="handleCurrentChangeGroupUser"
                              :prev-text="'<<'"
                              :next-text="'>>'"
                              :container-class="'pagination'"
                              :page-class="'page-item'">
                            </paginate>
                          </div>
                        </div>
                      </div>
                      <button class="btn-cus btn-right btn-add" type="button" @click="addUser(groupInfor.groupId)">
                      ユーザーの関連付けを追加
                      </button>
                      <a class="btn-cus btn-right btn-delete" href="#process" data-toggle="modal" @click="resetStatus()">チェックしたユーザーの関連付け解除</a>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a class="accordion-toggle" data-toggle="collapse" href="#relation-gate" @click="getDataGroupGate">
                        <i class="bigger-110 ace-icon fa fa-angle-right" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                        &nbsp;ゲート
                      </a>
                    </h4>
                  </div>
                  <div class="panel-collapse collapse" id="relation-gate" aria-expanded="true">
                    <div class="panel-body">
                      <table style="min-width:100%" class="table table-striped table-bordered table-hover dataTable">
                        <thead>
                          <tr>
                            <th class="center" v-if="listGateGroup!=null" style="width:50px!important">
                              <label class="pos-rel">
                                <input type="checkbox" class="ace" v-model="selectAllGate">
                                <span class="lbl"></span>
                              </label>
                            </th>
                            <th>ゲートID</th>
                            <th>ゲート名</th>
                            <th>製品名</th>
                            <th>備考.1</th>
                            <th>備考.2</th>
                            <th class="center">ステータス</th>
                          </tr>
                        </thead>
                        <tbody v-if="listGateGroup!=null">
                          <template v-for="(item, index) in listGateGroup">
                            <tr v-bind:class="{'selected': rowSelectedGate(item.relationId)}" :key="index" v-if="item.gateId.isValid">
                              <td class="center" style="width:50px">
                                <label class="pos-rel">
                                  <input type="checkbox" class="ace" :value="item.relationId" v-model="selectedGateId">
                                  <span class="lbl"></span>
                                </label>
                              </td>
                              <td>{{item.gateId.gateId}}</td>
                              <td>{{item.gateId.gateName}}</td>
                              <td>{{item.gateId.gateModelName}}</td>
                              <td>{{item.gateId.option1}}</td>
                              <td>{{item.gateId.option2}}</td>
                              <td class="center">{{item.gateId.status}}</td>
                            </tr>
                          </template>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="6">{{ messageData }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="row pd-t-10">
                        <div class="col-xs-12">
                          <div class="dataTables_paginate paging_simple_numbers" v-if="pagesGroupGate>0 && listGateGroup!==null">
                            <paginate
                              :page-count="pagesGroupGate"
                              :page-range="3"
                              :margin-pages="2"
                              :click-handler="handleCurrentChangeGroupGate"
                              :prev-text="'<<'"
                              :next-text="'>>'"
                              :container-class="'pagination'"
                              :page-class="'page-item'">
                            </paginate>
                          </div>
                        </div>
                      </div>
                      <button class="btn-cus btn-right btn-add" type="button" @click="addGate(groupInfor.groupId)">
                      ゲートの関連付けを追加
                      </button>
                      <a class="btn-cus btn-right btn-delete" href="#processGate" data-toggle="modal" @click="resetStatusGate()">チェックしたゲートの関連付け解除</a>
                    </div>
                  </div>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <!-- プロフィールModal -->
    <div id="process" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">関連付け解除</h3>
          </div>
          <div class="modal-body">
            <span class="progress-question">このユーザーとの関連付けを解除しますか？</span>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <span class="success-label" v-if="successUser>0">{{countUser}}件中{{successUser}}件を解除しました。</span>
            <div v-if="errorMessage.length>0">
            <span class="error-box-title">解除失敗</span>
            <div class="error-box">
              <template v-for="item in errorMessage">
                <p v-html="item" :key="item"></p>
              </template>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="deleteRelationUser()">実行</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <div id="processGate" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">関連付け解除</h3>
          </div>
          <div class="modal-body">
            <span class="progress-question">このゲートとの関連付けを解除しますか？</span>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <span class="success-label" v-if="successGate>0">{{countGate}}件中{{successGate}}件を解除しました。</span>
            <div v-if="errorMessage.length>0">
            <span class="error-box-title">解除失敗</span>
            <div class="error-box">
              <template v-for="item in errorMessage">
                <p v-html="item" :key="item"></p>
              </template>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="deleteRelationGate()">実行</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      errorMessageLogs: '',
      selectedUserId: [],
      selectedGateId: [],
      listGateGroup: null,
      listGateGroupTempData: null,
      listUserGroup: null,
      listUserGroupTempData: null,
      groupInfor: {
        groupId: '',
        name: '',
        isValid: false
      },
      groupId: '',
      flagU: false,
      flag: false,
      message_success: '',
      message_error: '',
      isDisabled: false,
      progress: 0,
      success: false,
      loading: false,
      errorMessage: [],
      successUser: 0,
      successGate: 0,
      errorName: '',
      countUser: 0,
      countGate: 0,
      exeCountUser: 0,
      exeCountGate: 0,
      percent: 0,
      pagesGroupUser: 0,
      pagesGroupGate: 0,
      exeCount: 0,
      exeCountGroupGate: 0,
      totalDataRow: 0,
      totalDataRowGroupGate: 0,
      messageData: 'データー取得中',
      listQuery: {
        currPage: 1,
        currPageGroupGate: 1,
        pageSize: 100
      },
      mukouGateId: 0
    }
  },
  watch: {
    'progress': 'checkProgress',
    exeCountUser: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countUser) {
        vm.deleteGroupPassage(this.selectedUserId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countUser) {
        vm.getInforUserGroup(this.groupId)
      }
    },
    exeCountGate: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countGate) {
        vm.deleteGate(this.selectedGateId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countGate) {
        vm.getInforGateGroup(this.groupId)
      }
    },
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalDataRow) {
        vm.getUserInfo(vm.listUserGroupTempData[newVal].userId, newVal)
      } else if (newVal === vm.totalDataRow) {
        vm.listUserGroup = vm.listUserGroupTempData
        vm.loading = false
      }
    },
    exeCountGroupGate: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalDataRowGroupGate) {
        vm.getGateInfo(vm.listGateGroupTempData[newVal].gateId, newVal)
      } else if (newVal === vm.totalDataRowGroupGate) {
        vm.listGateGroup = vm.listGateGroupTempData
        vm.loading = false
      }
    }
  },
  created () {
    var vm = this
    vm.getGroupData()
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAllUser: {
      get: function () {
        return this.listUserGroup ? this.selectedUserId.length === this.listUserGroup.length : false
      },
      set: function (value) {
        var selectedUserId = []
        if (value) {
          this.listUserGroup.forEach(function (item) {
            selectedUserId.push(item.groupPassageId)
          })
        }
        this.selectedUserId = selectedUserId
      }
    },
    selectAllGate: {
      get: function () {
        return this.listGateGroup ? (this.selectedGateId.length + this.mukouGateId) === this.listGateGroup.length : false
      },
      set: function (value) {
        var selectedGateId = []
        var vm = this
        if (value) {
          this.listGateGroup.forEach(function (item) {
            if (typeof item.gateId.gateId !== 'undefined') {
              selectedGateId.push(item.relationId)
            } else {
              vm.mukouGateId++
            }
          })
        }
        this.selectedGateId = selectedGateId
      }
    }
  },
  methods: {
    sort (sortkey, elementname) {
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('listGroupUserSortName', 'desc')
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('listGroupUserSortName', 'asc')
      }
      this.getInforUserGroup(this.groupId)
    },
    sortGroupGate (sortkey, elementname) {
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('listGroupGateSortName', 'desc')
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('listGroupGateSortName', 'asc')
      }
      this.getInforGateGroup(this.groupId)
    },
    getData () {
      if (this.listUserGroupTempData === null) {
        this.getInforUserGroup(this.groupId)
      }
    },
    getDataGroupGate () {
      if (this.listGateGroupTempData === null) {
        this.getInforGateGroup(this.groupId)
      }
    },
    handleCurrentChangeGroupUser (val) {
      this.selectedUserId = []
      this.listQuery.currPage = val
      this.exeCount = 0
      this.getInforUserGroup(this.groupId)
    },
    handleCurrentChangeGroupGate (val) {
      this.selectedGateId = []
      this.listQuery.currPageGroupGate = val
      this.exeCountGroupGate = 0
      this.getInforGateGroup(this.groupId)
    },
    checkProgress () {
      if (Math.round(this.progress) === 100) {
        this.success = true
        this.selectedUserId = []
        this.selectedGateId = []
      }
    },
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('このユーザーとの関連付けを解除しますか？')
      this.progress = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successUser = 0
      this.successGate = 0
      this.countUser = 0
      this.countGate = 0
      this.exeCountGate = 0
      this.exeCountUser = 0
    },
    resetStatusGate () {
      $('.progress').addClass('hide')
      $('.progress-question').html('このゲートとの関連付けを解除しますか？')
      this.progress = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successUser = 0
      this.successGate = 0
      this.countUser = 0
      this.countGate = 0
      this.exeCountGate = 0
      this.exeCountUser = 0
    },
    rowSelected (userId) {
      if (jQuery.inArray(userId, this.selectedUserId) !== -1) {
        return true
      } else {
        return false
      }
    },
    rowSelectedGate (userId) {
      if (jQuery.inArray(userId, this.selectedGateId) !== -1) {
        return true
      } else {
        return false
      }
    },
    getGateInfo (gateId, i) {
      var vm = this
      this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(gateId) + '&isValid=true')
        .then(response => {
          vm.listGateGroupTempData[i].gateId = response.body.gates[0]
          vm.exeCountGroupGate++
        })
        .catch(error => {
          vm.exeCountGroupGate++
          console.log(error)
        })
    },
    getInforGateGroup (groupId) {
      var vm = this
      vm.loading = true
      vm.exeCountGroupGate = 0
      this.$http.get(Config.RELATION_GATE_GROUP_API + '?groupId=' + encodeURIComponent(groupId) + '&limit=25&page=' + this.listQuery.currPageGroupGate + '&sortKey=desc:gateId')
        .then(response => {
          console.log(response)
          this.pagesGroupGate = Math.ceil((response.body.maxRecords) / 25)
          vm.listGateGroupTempData = response.body.relationsGateGroup
          vm.totalDataRowGroupGate = vm.listGateGroupTempData.length
          vm.getGateInfo(vm.listGateGroupTempData[0].gateId, 0)
        })
        .catch((error) => {
          vm.loading = false
          vm.listGateGroup = null
          vm.messageData = 'データーはありません'
          console.log(error)
        })
    },
    getUserInfo (userId, i) {
      var vm = this
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          vm.listUserGroupTempData[i].userId = response.body.users[0]
          vm.exeCount++
        })
        .catch(error => {
          vm.exeCount++
          console.log(error)
        })
    },
    getInforUserGroup (groupId) {
      var vm = this
      vm.loading = true
      vm.exeCount = 0
      this.$http.get(Config.GROUPS_PASSAGE_API + '?groupId=' + encodeURIComponent(groupId) + '&limit=25&page=' + this.listQuery.currPage + '&sortKey=desc:userId')
        .then(response => {
          console.log(response)
          this.pagesGroupUser = Math.ceil((response.body.maxRecords) / 25)
          vm.listUserGroupTempData = response.body.groupPassages
          vm.totalDataRow = vm.listUserGroupTempData.length
          vm.getUserInfo(vm.listUserGroupTempData[0].userId, 0)
        })
        .catch((error) => {
          vm.loading = false
          vm.listUserGroup = null
          vm.messageData = 'データーはありません'
          console.log(error)
        })
    },
    validateBeforeSubmit () {
      this.flag = true
      if (this.groupInfor.name === null || this.groupInfor.name === '') {
        $('#name_error').html('ゲートグループ名は必須です。')
        $('#name').addClass('error')
        this.flagU = false
      } else {
        $('#name_error').html('')
        $('#name').removeClass('error')
        this.flagU = true
      }
      if (this.groupInfor.name !== null && this.groupInfor.name !== '') {
        if (this.groupInfor.name.length > 64) {
          $('#name_error').html('ゲートグループ名は64文字以内入力してください。')
          $('#name').addClass('error')
          this.flag = false
        } else {
          $('#name_error').html('')
          $('#name').removeClass('error')
          this.flag = true
        }
      }
      if (this.flag && this.flagU) {
        this.editInforGroup()
      }
    },
    reset () {
      this.groupInfor.name = ''
      this.groupInfor.isValid = false
    },
    getGroupData () {
      var vm = this
      var data = this.$route.query
      vm.groupId = data.id
      this.$http.get(Config.GROUPS_LIST_API + '?groupId=' + encodeURIComponent(vm.groupId))
        .then(response => {
          vm.groupInfor.groupId = response.body.groups[0].groupId
          vm.groupInfor.name = response.body.groups[0].name
          vm.groupInfor.isValid = response.body.groups[0].isValid
        })
        .catch(error => {
          console.log(error)
        })
    },
    editInforGroup () {
      var vm = this
      this.errorMessageLogs = ''
      vm.loading = true
      const Infor = {
        name: vm.groupInfor.name,
        isValid: vm.groupInfor.isValid
      }
      this.$http.put(Config.GROUPS_LIST_API + '/' + encodeURIComponent(vm.groupInfor.groupId), Infor)
        .then(response => {
          this.loading = false
          this.message_success = Config.EDIT_GROUP_API_SUCCESS
          this.message_error = ''
        })
        .catch((error) => {
          this.loading = false
          this.message_success = ''
          switch (error.status) {
            case 400:
              this.message_error = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.message_error = '該当するデーターがありません。'
              break
            case 409:
              this.message_error = '入力されたゲートグループ名は既に使用されています。他のゲートグループ名を入力してください。'
              break
            case 500:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    addGate (groupId) {
      var pagesGroupGate = this.pagesGroupGate
      this.$router.push({name: 'groupgateadd', query: { id: groupId, gatePage: pagesGroupGate }})
    },
    addUser (groupId) {
      var pagesGroupUser = this.pagesGroupUser
      this.$router.push({name: 'groupuseradd', query: { id: groupId, userPage: pagesGroupUser }})
    },
    deleteGroupPassage (groupPassageId, percent, i) {
      this.$http.delete(Config.GROUPS_PASSAGE_API + '/' + encodeURIComponent(groupPassageId))
        .then(response => {
          this.progress += percent
          this.successUser += 1
          this.exeCountUser++
        })
        .catch((error) => {
          this.progress += percent
          switch (error.status) {
            case 403:
              this.errorName = 'ゲートグループ通行権限の削除権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = groupPassageId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          this.exeCountUser++
        })
    },
    deleteRelationUser () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedUserId.length > 0) {
        this.countUser = this.selectedUserId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedUserId.length)
        vm.deleteGroupPassage(this.selectedUserId[0], vm.percent, 0)
      } else {
        alert('少なくてもユーザーを１つ選んでください。')
      }
    },
    deleteGate (relationId, percent, i) {
      this.$http.delete(Config.RELATION_GATE_GROUP_API + '/' + encodeURIComponent(relationId))
        .then(response => {
          this.progress += percent
          this.successGate += 1
          this.exeCountGate++
        })
        .catch((error) => {
          this.progress += percent
          switch (error.status) {
            case 403:
              this.errorName = 'ゲート関連付け情報の削除権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = relationId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          this.exeCountGate++
        })
    },
    deleteRelationGate () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedGateId.length > 0) {
        this.countGate = this.selectedGateId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / vm.countGate)
        vm.deleteGate(this.selectedGateId[0], vm.percent, 0)
      } else {
        alert('少なくてもゲートを１つ選んでください。')
      }
    }
  }
}
</script>
<style>
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    border-radius: 10px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/group/GroupEdit.vue